import { useEffect, useState } from "react";
import api from "@/lib/api";
import { attachAutoFlush, flushQueue, isOnline, queueSize } from "@/lib/offlineQueue";
import { toast } from "sonner";

export function useOffline() {
  const [online, setOnline] = useState(isOnline());
  const [pending, setPending] = useState(queueSize());

  useEffect(() => {
    const onOnline = () => setOnline(true);
    const onOffline = () => setOnline(false);
    const onQueueChange = (e) => setPending(e?.detail?.size ?? queueSize());
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    window.addEventListener("bkpro-queue-change", onQueueChange);
    const detach = attachAutoFlush(api, (r) => {
      if (r.flushed > 0) toast.success(`Synchronisation OK — ${r.flushed} action${r.flushed > 1 ? "s" : ""}`);
      if (r.failed > 0) toast.error(`${r.failed} action${r.failed > 1 ? "s ont" : " a"} échoué`);
      setPending(queueSize());
    });
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
      window.removeEventListener("bkpro-queue-change", onQueueChange);
      detach?.();
    };
  }, []);

  const forceFlush = async () => {
    const r = await flushQueue(api);
    setPending(queueSize());
    return r;
  };

  return { online, pending, forceFlush };
}
